module.exports = __webpack_public_path__ + "assets/img/2.01e029b1.png";